import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { UserShowDto } from "apiGen";
import { FormikErrors } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { usersService } from "~shared/api/users";
import { RoleMultiSelect } from "./RoleMultiSelect";

export type IUserFormState = Omit<UserShowDto, "id" | "password">;

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IUserFormState) => {
		const errors: FormikErrors<IUserFormState> = {};

		if (!values.firstName) {
			errors.firstName = t("Field is required");
		}
		if (!values.lastName) {
			errors.lastName = t("Field is required");
		}
		if (!values.email) {
			errors.email = t("Field is required");
		}

		return errors;
	};
};

const UserDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField label={t("First name")} name="firstName" />
			<TextField label={t("Last name")} name="lastName" />
			<TextField label={t("Email")} name="email" />
			<TextField label={t("Company")} name="company" />
			<TextField label={t("Position")} name="position" />
			<RoleMultiSelect label={t("Roles")} name="roles" />
		</FormDrawerContent>
	);
};

export const UserCreateDrawer: FC<CreateDrawerFormProps<IUserFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: IUserFormState = {
		firstName: "",
		lastName: "",
		email: "",
		roles: [],
	};

	return (
		<FormDrawer
			{...drawerProps}
			validate={validate}
			title={t("Create user")}
			initialValues={initialValues}
			renderForm={(props) => <UserDrawerContent {...props} />}
		/>
	);
};

export const UserUpdateDrawer: FC<UpdateDrawerFormProps<IUserFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			title={t("Edit user")}
			validate={validate}
			queryFn={() => usersService.show(drawerProps.id).then((x) => x.data.data)}
			queryKey={usersService.showKey(drawerProps.id)}
			renderSuccess={(props) => <UserDrawerContent {...props} />}
		/>
	);
};
